import { banMemberCommunity } from 'src/client/Communities'
import useMutation from '../useMutation/useMutation'

export type BanMutationParams = {
  collectionId: number
  userId: number
}

const useBanMember = () => {
  const banMemberCommunityMutation = useMutation(({ collectionId, userId }: BanMutationParams) =>
    banMemberCommunity(collectionId, userId)
  )

  return banMemberCommunityMutation
}

export default useBanMember
